import cn from "@/utils/mergeClassNames";

type Props = {
  className?: string;
};

export default function Background({ className }: Props) {
  return <div className={cn("fixed inset-0 -z-100", className)} />;
}
